import { render } from "./MenuAspirante.vue?vue&type=template&id=82e8b736&scoped=true&class=transparent"
import script from "./MenuAspirante.vue?vue&type=script&lang=js"
export * from "./MenuAspirante.vue?vue&type=script&lang=js"

import "./MenuAspirante.vue?vue&type=style&index=0&id=82e8b736&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e8b736"]])

export default __exports__